import CivilEsencial from "./CivilEsencial";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "civil-esencial",
  tipoEvento: "civil",
  tipoEtiqueta: "Civil íntimo",
  nombre: "Esencial",
  descripcion:
    "Minimalismo cálido para bodas civiles e íntimas: tipografía ligera protagonista, fecha como eje visual y una sola fotografía panorámica. Sin adornos, con aire.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    lino: "/miniaturas/civil-esencial-lino.jpg",
    grafito: "/miniaturas/civil-esencial-grafito.jpg",
    rosario: "/miniaturas/civil-esencial-rosario.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: CivilEsencial,
};
